// extracted by mini-css-extract-plugin
export default {"object_fit_cover":"Image_object_fit_cover__x-fhh"};